import React from 'react';
import './FloatMobile.css';

export function FloatMobile() {
  return (
    <div className="float-mobile">
      <img
        src="/images/aimers_mobile_3d.jpg"
        alt="AIMERS 3D Mobile App"
        className="float-mobile__img"
      />
    </div>
  );
}
